module.exports = __webpack_public_path__ + "static/3ec57ca6-1d4f-4ae4-9fa9-fad00dfa2e1a-58b27a8728356f4a5dd2ef3cb4c816e5.jpg";